var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
export var prepRoute = function (View) { return ({
    match: function (type) {
        return type === "Video";
    },
    page: function (_a) {
        var data = _a.data;
        return React.createElement(View, { data: fromSecondsToMs(data) });
    },
}); };
function fromSecondsToMs(video) {
    return __assign(__assign({}, video), { duration: video.duration * 1000 });
}
